import React from "react";
import { AiGeneratedLabelSvg } from "../../../../../../layout/components/icons/iconsSvg";
import "./style.scss";
const AiGeneratedLabel = () => {
    return (React.createElement("div", { className: "ai-generated-label" },
        React.createElement("span", { className: "ai-icon" },
            React.createElement(AiGeneratedLabelSvg, null)),
        "AI Generated"));
};
export default AiGeneratedLabel;
